import React, { useState, useEffect } from "react";
import { Button, Grid, Group, Modal, Paper, TextInput } from "@mantine/core";
import { IconFilter, IconSearch, IconTable } from "@tabler/icons";
import { QueryBuilder } from "react-querybuilder";
import { Table } from "@tanstack/react-table";

export const Toolbar = ({ table }: { table: Table<unknown> }) => {
  const [opened, setOpened] = useState(false);
  const [fields, setFields] = useState<any[]>([]);

  useEffect(() => {
    let arr: any[] = [];
    table.getAllLeafColumns().map((column) => {
      arr.push({
        id: column.id,
        name: column.id,
        label: column.id,
      });
      // return (
      //   <div key={column.id} className="px-1">
      //     <label>
      //       <input
      //         {...{
      //           type: 'checkbox',
      //           checked: column.getIsVisible(),
      //           onChange: column.getToggleVisibilityHandler(),
      //         }}
      //       />{' '}
      //       {column.id}
      //     </label>
      //   </div>
      // )
    });
    setFields(arr);
  }, []);

  return (
    <>
      <Paper
        p="sm"
        withBorder
        radius={0}
        sx={(theme) => ({
          borderBottom: 0,
          backgroundColor:
            theme.colorScheme === "dark"
              ? theme.colors.dark[3]
              : theme.colors.gray[1],
        })}
      >
        <Grid>
          <Grid.Col span={4}>
            <TextInput
              placeholder="Search by any field"
              icon={<IconSearch size={14} stroke={1.5} />}
              // value={search}
              // onChange={handleSearchChange}
            />
          </Grid.Col>
          <Grid.Col span={8}>
            <Group sx={{ justifyContent: "end" }}>
              <Button leftIcon={<IconTable />} variant="default">
                Columns
              </Button>
              <Button
                leftIcon={<IconFilter />}
                variant="default"
                onClick={() => setOpened(true)}
              >
                Filters
              </Button>
            </Group>
          </Grid.Col>
        </Grid>
      </Paper>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Filters"
        closeOnClickOutside={false}
        size="lg"
      >
        <QueryBuilder fields={fields} showCombinatorsBetweenRules={true} />
      </Modal>
    </>
  );
};
